import React from "react";
import { cn } from "@/lib/utils";

/**
 * StatusChip — soft pastel pill for brief / task status.
 * Calm, not shouty. Apple-minimal palette.
 *
 * Usage:
 *   <StatusChip status="Pitched" />
 *   <StatusChip status="In Progress" size="sm" />
 */

const STATUS_STYLES = {
  // Brief statuses
  "New": "bg-[var(--s2)] text-[var(--t2)]",
  "Assigned": "bg-teal-500/10 text-teal-300",
  "In Progress": "bg-violet-500/12 text-violet-300",
  "Pitched": "bg-fuchsia-500/10 text-fuchsia-300",
  "Won": "bg-green-500/12 text-green-300",
  "Executed": "bg-green-500/12 text-green-300",
  "Lost": "bg-[var(--s2)] text-[var(--t3)]",
  "On Hold": "bg-[var(--s2)] text-[var(--t3)]",
  // Task statuses
  "Open": "bg-slate-500/12 text-slate-300",
  "Review": "bg-amber-500/12 text-amber-300",
  "Paused": "bg-[var(--s2)] text-[var(--t3)]",
  "Done": "bg-green-500/12 text-green-300",
  // Default
  "_": "bg-[var(--s2)] text-[var(--t2)]",
};

export function StatusChip({ status, size = "md", className }) {
  const styleKey = STATUS_STYLES[status] ? status : "_";
  const sizeClass = size === "sm"
    ? "px-2 py-0.5 text-[10px]"
    : "px-2.5 py-[3px] text-[11px]";
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full font-medium whitespace-nowrap",
        STATUS_STYLES[styleKey],
        sizeClass,
        className
      )}
    >
      {status}
    </span>
  );
}

export default StatusChip;
